import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import AccessControlService from "../services/AccessControlService";
import Spinner from "../components/Spinner";

//Import all possible pages
import PageMgn from "../components/PageMgn";
import UserMgn from "../components/UserManagement";
import Settings from "../components/Settings";
import AccessControl from "../components/AccessControl";
import OrganizationalChart from "../components/OrganizationalChart";
import AppointmentParameters from "../components/AppointmentParameters";
import Appointment from "../components/Appointment";
import ProcessTypes from "../components/ProcessTypes";
import Workflows from "../components/workflow/Workflows";
import MyTasks from "../components/MyTasks";
import MyRequests from "../components/MyRequests";
import LeaveRequests from "../components/LeaveRequest";
import LeaveSettings from '../components/LeaveSettings';
import BonusTypes from '../components/BonusTypes';
import BonusRequests from '../components/BonusRequests';
import UserDocumentType from '../components/UserDocumentType';
import Announcements from '../components/Announcements';
import DesktopManagement from '../components/DesktopManagement';
import UserOrgInfo from '../components/UserOrgInfo';
import MessageCategoryManager from '../components/MessageCategories';
import Messages from '../components/message/Messages';
import WorkflowAssignment from '../components/workflow/WorkflowAssignment';
import Tickets from '../components/Tickets';
import TicketTypes from '../components/TicketTypes';
import Tasks from '../components/Tasks';
import AuditorAssignment from '../components/AuditorAssignment';

//Map menu paths to components
const componentMap = {
    pageMgn: PageMgn,
    userMgn: UserMgn,
    settings: Settings,
    accessControl: AccessControl,
    orgChart: OrganizationalChart,
    appointmentParameters: AppointmentParameters,
    appointment: Appointment,
    processTypes: ProcessTypes,
    workflows: Workflows,
    leaveRequests: LeaveRequests,
    myTasks: MyTasks,
    myRequests: MyRequests,
    leaveSettings: LeaveSettings,
    bonusTypes: BonusTypes,
    bonusRequests: BonusRequests,
    userDocumentType: UserDocumentType,
    announcements: Announcements,
    desktopManagement: DesktopManagement,
    userOrgInfo: UserOrgInfo,
    messageCategories: MessageCategoryManager,
    messages: Messages,
    workflowAssignments: WorkflowAssignment,
    tickets: Tickets,
    ticketTypes: TicketTypes,
    tasks: Tasks,
    auditorAssignments: AuditorAssignment
};

const DynamicPage = () => {
    const { pageName } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const { user } = useContext(AuthContext);
    const [darkMode, setDarkMode] = useState(false);

    // Get dark mode preference from UserDashboard
    useEffect(() => {
        const root = document.documentElement;
        const isDarkMode = root.getAttribute('data-theme') === 'dark';
        setDarkMode(isDarkMode);
    }, []);

    useEffect(() => {
        const checkAccess = async () => {
            try {
                if (!user || !pageName) {
                    navigate('/unauthorized');
                    return;
                }

                // Skip access check for user type 0 (admin/superuser)
                if (user.userType === 0) {
                    setLoading(false);
                    return;
                }

                // Skip access check for userOrgInfo as it's available to all authenticated users
                if (pageName === 'userOrgInfo') {
                    setLoading(false);
                    return;
                }

                const hasAccess = await AccessControlService.checkPageAccess(user.userId, pageName);
                if (!hasAccess) {
                    navigate('/unauthorized');
                    return;
                }

                setLoading(false);
            } catch (error) {
                console.error('Error checking page access:', error);
                navigate('/unauthorized');
            }
        };

        checkAccess();
    }, [pageName, navigate, user]);

    if (loading) {
        return <Spinner />;
    }

    const PageComponent = componentMap[pageName] || (() => <h2>Page Not Found</h2>);
    return <PageComponent darkMode={darkMode} />;
};

export default DynamicPage;
